// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"72034a2c","340":"72034a2c","441":"72034a2c","587":"f18f0441","783":"829ee1bd","897":"72034a2c","898":"72034a2c"}[chunkId] + ".chunk.css";
};